import React, { useState, useEffect } from "react";
import { Popup } from 'reactjs-popup';
import { Link } from 'react-router-dom';
import { getHours, getMinutes } from 'date-fns';

import { FaStar, FaRegStar, FaBell, FaTimes } from "react-icons/fa";
import { VscTriangleDown, VscTriangleUp, VscClearAll } from "react-icons/vsc";

import Navbar from "../../components/Navbar.js";
import Card from "../../components/Card.js";

const SearchPage = () => {
  const [searchResults, setSearchResults] = useState([]);

  const [filters, setFilters] = useState({
   college: {
      'CAS': false,
      'CAFS': false,
      'CDC': false,
      'CEM': false,
      'CEAT': false,
      'CFNR': false,
      'CHE': false,
      'CVM': false,
      'CPAF': false,
   },
   building: {
      'Physical Sciences': false,
      'casa1': false,
      'casa2': false,
      'casb': false,
      'su': false,
      'CEM Building': false,
      'IBS and CPC Greenhouses and Annex Offices': false,
      'Francisco O. Santos Hall': false,
   },
   classification: {
      'bidet': false,
      'tissue_paper': false,
      'soap': false,
      'hand_dryer': false,
      'pwd_toilet': false,
   },
   gender: {
      'male': false,
      'female': false,
   },
   rating: {
      '5': false,
      '4': false,
      '3': false,
      '2': false,
      '1': false,
   },
   time: {
      'isOpen': false,
   },
  });

  const handleCheckboxChange = (category, value) => {
   setFilters(prevState => ({
      ...prevState,
      [category]: {
        ...prevState[category],
        [value]: !prevState[category][value]
      }
   }));
  };

  const clearFilters = () => {
   setFilters({
    college: {
        'CAS': false,
        'CAFS': false,
        'CDC': false,
        'CEM': false,
        'CEAT': false,
        'CFNR': false,
        'CHE': false,
        'CVM': false,
        'CPAF': false,
     },
     building: {
        'Physical Sciences': false,
        'casa1': false,
        'casa2': false,
        'casb': false,
        'su': false,
        'CEM Building': false,
        'IBS and CPC Greenhouses and Annex Offices': false,
        'Francisco O. Santos Hall': false,
     },
     classification: {
        'bidet': false,
        'tissue_paper': false,
        'soap': false,
        'hand_dryer': false,
        'pwd_toilet': false,
     },
     gender: {
        'male': false,
        'female': false,
     },
     rating: {
        '5': false,
        '4': false,
        '3': false,
        '2': false,
        '1': false,
     },
     time: {
       isOpen: false,
     },
   });
  };

  useEffect(() => {
    // Define the categories you want to filter
    const categories = ['college', 'building', 'classification', 'gender', 'time', 'rating'];

    // Function to fetch filtered data
    const fetchFilteredData = async () => {
      const filterRequests = [];

      // Loop through each category
      Object.keys(filters).forEach(category => {
        // Filter out only the checked items
        const checkedItems = Object.keys(filters[category]).filter(value => filters[category][value]);

        if (category === 'time') {
          if (filters.time['isOpen']) {
            // Get the current time in [hour, minute] format
            const currentHour = getHours(new Date());
            const currentMinute = getMinutes(new Date());
            const currentTimeArray = [currentHour, currentMinute];
            console.log(currentTimeArray);
            
            // Construct the query string for "Open Now"
            const timeQueryString = `time=${encodeURIComponent(JSON.stringify(currentTimeArray))}`;
            filterRequests.push(
              fetch(`https://uplbidet-api.vercel.app/api/cr/filter?${timeQueryString}`)
                .then(response => response.json())
                .catch((error) => {
                  console.error('Error:', error);
                })
            );
          }
          return;
        }else{

          if (checkedItems.length > 0) {
            // Construct the query string with multiple values for the same parameter
            const queryString = checkedItems.map(item => `${category}=${encodeURIComponent(item)}`).join('&');

            // Add a request with the constructed query string
            filterRequests.push(
              fetch(`https://uplbidet-api.vercel.app/api/cr/filter?${queryString}`)
                .then(response => response.json())
                .catch((error) => {
                  console.error('Error:', error);
                })
            );
          }
        }

        // Check if any item is checked for the category
      });

      try {
        // Wait for all filter requests to complete
        const dataArray = await Promise.all(filterRequests);
        // Combine data from all requests into a single array
        const combinedData = dataArray.reduce((acc, curr) => acc.concat(curr), []);
        const uniqueData = combinedData.filter(
          (item, index, self) => index === self.findIndex(obj => obj._id === item._id)
        );
        // Update searchResults state with the combined data
        setSearchResults(uniqueData);
      } catch (error) {
        console.error('Error:', error);
      }
    };

    // Function to fetch all data when no filters are applied
    const fetchAllData = async () => {
      try {
        const response = await fetch('https://uplbidet-api.vercel.app/api/cr/available');
        const data = await response.json();
        // Update searchResults state with all comfort rooms data
        setSearchResults(data);
      } catch (error) {
        console.error('Error: fetching data', error);
      }
    };

    // Check if any filters are applied
    const filtersApplied = Object.values(filters).some(category => Object.values(category).some(value => value));

    // Fetch data based on whether filters are applied or not
    filtersApplied ? fetchFilteredData() : fetchAllData();
        console.log(searchResults);

  }, [filters]);  // Depend on filters to trigger the effect when filters change


  // State to manage whether the popup is open or not
  const [open, setOpen] = useState(false);

  // State to track the viewport size
  const [isSmallViewport, setIsSmallViewport] = useState(window.innerWidth < 818);

  // Effect to update isSmallViewport on window resize
  useEffect(() => {
    // Function to handle window resize events
    const handleResize = () => {
      // Update isSmallViewport based on the current window width
      setIsSmallViewport(window.innerWidth < 995);
    };

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // For sorting, trying to keep it similar to the one on Home
  const [activeButton, setActiveButton] = useState("BEST");

  const handleButtonClick = (button) => {
    setActiveButton(button);
  };

  // sorting logic
  const sortDescending = () => {
    return searchResults.slice().sort((a, b) => b.average_rating - a.average_rating);
  };

  const sortAscending = () => {
    return searchResults.slice().sort((a, b) => a.average_rating - b.average_rating);
  };

  // Function to fetch review by ID
  const getReviewById = async (reviewId) => {
    try {
      const response = await fetch(`https://uplbidet-api.vercel.app/api/reviews/${reviewId}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const reviewData = await response.json();
      console.log(reviewData);
      return reviewData;
    } catch (error) {
      console.error('Error fetching review:', error);
      throw error; // Re-throw the error for further handling if needed
    }
  };

  const getReviewTime = async (comfortroom) => {
    const { _id, recent_review } = comfortroom;
    if (recent_review) {
      const review = getReviewById(recent_review);
      if (review) {
        console.log(`Comfortroom ${_id}: Recent Review Time Published: ${review.time_published}`);
        return review.time_published;
      } else {
        console.log(`Comfortroom ${_id}: Recent Review not found.`);
        console.log(`Comfortroom ${_id}: Time Published: ${comfortroom.time_published}`);
        return comfortroom.time_published;
      }
    } else {
      console.log(`Comfortroom ${_id}: No Recent Review.`);
      console.log(`Comfortroom ${_id}: Time Published: ${comfortroom.time_published}`);
      return comfortroom.time_published;
    }
  }

  const sortRecent = () => {
    return searchResults.slice().sort((a, b) => new Date(getReviewTime(a)) - new Date(getReviewTime(b)));
  };

  const sortedResults = () => {
    let sortedData;
    if (activeButton === "BEST") {
      sortedData = sortDescending();
    }else if (activeButton === "WORST"){
      sortedData = sortAscending();
    }else if (activeButton === "RECENT"){
      sortedData = sortRecent();
    }
    return sortedData.map((item) => (
      <Link
        key={item._id}
        to={`/detail/${item._id}`}
        style={{ textDecoration: "none", color: "black" }}
      >
        <Card data={item} activeButton={activeButton} />
      </Link>
    ));
  }

  const [showHidden, setshowHidden] = useState(false);

  const handleShowHidden = () => {
    setshowHidden(!showHidden);
    console.log(showHidden);
  };


  return(
    <>
      <Navbar />
      <div className="main-content">

        <p className="search-heading"><b>SEARCH RESULTS</b></p><br/>

        <div className="search-content">

          {!isSmallViewport ? (
            // Show filters normally for large viewports
            <div className="filter">
              <h2>Search Filter</h2><br/>

              <h3>By College</h3>
              <div className="byCollege">
                <div className="filterCheckbox">

                  <label><input 
                          className="collegeCheck"
                          type="checkbox"
                          checked={filters.college['CAS']}
                          onChange={() => handleCheckboxChange('college', 'CAS')}
                          /> CAS (College of Arts and Sciences)</label><br/><br/>
                  <label><input 
                          className="collegeCheck"
                          type="checkbox"
                          checked={filters.college['CAFS']}
                          onChange={() => handleCheckboxChange('college', 'CAFS')}
                          /> CAFS (College of Agriculture and Food Sciences)</label><br/><br/>
                  <label><input 
                          className="collegeCheck"
                          type="checkbox"
                          checked={filters.college['CDC']}
                          onChange={() => handleCheckboxChange('college', 'CDC')}
                          /> CDC (College of Development Communication)</label><br/><br/>
                  <label><input
                          className="collegeCheck"
                          type="checkbox"
                          checked={filters.college['CEM']}
                          onChange={() => handleCheckboxChange('college', 'CEM')}
                          /> CEM (College of Economics and Management)</label><br/><br/>
                  <label><input 
                          className="collegeCheck"
                          type="checkbox"
                          checked={filters.college['CEAT']}
                          onChange={() => handleCheckboxChange('college', 'CEAT')}
                          /> CEAT (College of Engineering and Agro-Industrial Technology)</label><br/><br/>
                  <label><input 
                          className="collegeCheck"
                          type="checkbox"
                          checked={filters.college['CFNR']}
                          onChange={() => handleCheckboxChange('college', 'CFNR')}
                          /> CFNR (College of Forestry and Natural Resources)</label><br/><br/>
                  <label><input 
                          className="collegeCheck"
                          type="checkbox"
                          checked={filters.college['CHE']}
                          onChange={() => handleCheckboxChange('college', 'CHE')}
                          /> CHE (College of Human Ecology)</label><br/><br/>
                  <label><input of
                          className="collegeCheck"
                          type="checkbox"
                          checked={filters.college['CVM']}
                          onChange={() => handleCheckboxChange('college', 'CVM')}
                          /> CVM (Colege of Veterinary Medicine)</label><br/><br/>
                  <label><input 
                          className="collegeCheck" 
                          type="checkbox" 
                          checked={filters.college['CPAF']}
                          onChange={() => handleCheckboxChange('college', 'CPAF')}
                          /> CPAf (College of Public Affairs and Development)</label><br/><br/>

                </div>
              </div>
              <br/>

              <h3>By Building</h3>
              <div className="byBuilding">
                <div className="filterCheckbox">

                  <label><input 
                          className="buildingCheck" 
                          type="checkbox" 
                          checked={filters.building['Physical Sciences']}
                          onChange={() => handleCheckboxChange('building', 'Physical Sciences')}
                          /> Physical Sciences Building</label><br/><br/>
                  <label><input 
                          className="buildingCheck" 
                          type="checkbox" 
                          checked={filters.building['casa1']}
                          onChange={() => handleCheckboxChange('building', 'casa1')}
                          /> CAS Annex 1</label><br/><br/>
                  <label><input 
                          className="buildingCheck" 
                          type="checkbox" 
                          checked={filters.building['casa2']}
                          onChange={() => handleCheckboxChange('building', 'casa2')}
                          /> CAS Annex 2</label><br/><br/>
                  <label><input 
                          className="buildingCheck" 
                          type="checkbox" 
                          checked={filters.building['casb']}
                          onChange={() => handleCheckboxChange('building', 'casb')}
                          /> CAS Building</label><br/><br/>
                  <label><input 
                          className="buildingCheck" 
                          type="checkbox" 
                          checked={filters.building['su']}
                          onChange={() => handleCheckboxChange('building', 'su')}
                          /> Student Union Building</label><br/><br/>
                  <label><input 
                          className="buildingCheck" 
                          type="checkbox" 
                          checked={filters.building['CEM Building']}
                          onChange={() => handleCheckboxChange('building', 'CEM Building')}
                          /> CEM Building</label><br/><br/>
                  {!showHidden ? (
                    <button className="showButton" onClick={handleShowHidden}><VscTriangleDown className="symbol"/> Show More</button>
                  ) : (
                    <>
                      <label><input 
                              className="buildingCheck" 
                              type="checkbox" 
                              checked={filters.building['IBS and CPC Greenhouses and Annex Offices']}
                              onChange={() => handleCheckboxChange('building', 'IBS and CPC Greenhouses and Annex Offices')}
                              /> IBS and CPC Greenhouses and Annex Offices</label><br/><br/>
                      <label><input 
                              className="buildingCheck" 
                              type="checkbox" 
                              checked={filters.building['Francisco O. Santos Hall']}
                              onChange={() => handleCheckboxChange('building', 'Francisco O. Santos Hall')}
                              /> Francisco O. Santos Hall</label><br/><br/>
                      <button className="showButton" onClick={handleShowHidden}><VscTriangleUp className="symbol"/> Show Less</button>
                    </>
                  )}
                </div>
              </div>
              <br/>

              <h3>Classification</h3>
              <div className="byClassification">
                <div className="filterCheckbox">
      
                  <label><input 
                          className="classCheck" 
                          type="checkbox" 
                          checked={filters.classification['isOpen']}
                          onChange={() => handleCheckboxChange('time', 'isOpen')}
                          /> Open Now</label><br/><br/>
                  <label><input 
                          className="classCheck" 
                          type="checkbox" 
                          checked={filters.classification['bidet']}
                          onChange={() => handleCheckboxChange('classification', 'bidet')}
                          /> Bidet</label><br/><br/>
                  <label><input 
                          className="classCheck" 
                          type="checkbox" 
                          checked={filters.classification['tissue_paper']}
                          onChange={() => handleCheckboxChange('classification', 'tissue_paper')}
                          /> Tissue Paper</label><br/><br/>
                  <label><input 
                          className="classCheck" 
                          type="checkbox" 
                          checked={filters.classification['soap']}
                          onChange={() => handleCheckboxChange('classification', 'soap')}
                          /> Soap</label><br/><br/>
                  <label><input 
                          className="classCheck" 
                          type="checkbox" 
                          checked={filters.classification['hand_dryer']}
                          onChange={() => handleCheckboxChange('classification', 'hand_dryer')}
                          /> Hand Dryer</label><br/><br/>
                  <label><input 
                          className="classCheck" 
                          type="checkbox" 
                          checked={filters.classification['pwd_toilet']}
                          onChange={() => handleCheckboxChange('classification', 'pwd_toilet')}
                          /> PWD Toilet</label><br/><br/>
                  <label><input 
                          className="classCheck" 
                          type="checkbox" 
                          checked={filters.gender['male']}
                          onChange={() => handleCheckboxChange('gender', 'male')}
                          /> Male Restroom</label><br/><br/>
                  <label><input 
                          className="classCheck" 
                          type="checkbox" 
                          checked={filters.gender['female']}
                          onChange={() => handleCheckboxChange('gender', 'female')}
                          /> Female Restroom</label><br/><br/>
      
                </div>
              </div>
              <br/>

              <h3>Ratings</h3>
              <div className="byRatings">
                <div className="filterCheckbox">

                  <label><input 
                          className="rateCheck" 
                          type="checkbox" 
                          rel="five" 
                          checked={filters.rating['5']}
                          onChange={() => handleCheckboxChange('rating', '5')}
                          /> 5 Stars</label><br/><br/>
                  <label><input 
                          className="rateCheck" 
                          type="checkbox" 
                          rel="four" 
                          checked={filters.rating['4']}
                          onChange={() => handleCheckboxChange('rating', '4')}
                          /> 4 Stars and up</label><br/><br/>
                  <label><input 
                          className="rateCheck" 
                          type="checkbox" 
                          rel="three" 
                          checked={filters.rating['3']}
                          onChange={() => handleCheckboxChange('rating', '3')}
                          /> 3 Stars and up</label><br/><br/>
                  <label><input 
                          className="rateCheck" 
                          type="checkbox" 
                          rel="two" 
                          checked={filters.rating['2']}
                          onChange={() => handleCheckboxChange('rating', '2')}
                          /> 2 Stars and up</label><br/><br/>
                  <label><input 
                          className="rateCheck" 
                          type="checkbox" 
                          rel="one" 
                          checked={filters.rating['1']}
                          onChange={() => handleCheckboxChange('rating', '1')}
                          /> 1 Star and up</label><br/><br/>

                </div>
              </div>
              <br/>

              <button className="clearFilter" onClick={clearFilters}><FaTimes className="symbol"/> Clear All</button>
            </div>
          ) : null}

          <div className="results">
            <h2 className="sortTitle">Sort By:</h2>
            <div className="card-buttons-container">
              {isSmallViewport ? (
                // Show filters as a button with a popup for small viewports
                <div className="filterPopup">
                  <button className="button regular" onClick={() => setOpen(true)}>Show Filters</button>
                  <Popup 
                    className="popupContent" 
                    open={open} 
                    onClose={() => setOpen(false)}
                  >
                    <div className="filter extra">

                      <h2>Search Filter</h2><br/>

                      <button className="closeButton" onClick={() => setOpen(false)}>
                        <FaTimes />
                      </button>

                      <h3>By College</h3>
                      <div className="byCollege">
                        <div className="filterCheckbox">

                          <label><input 
                                  className="collegeCheck"
                                  type="checkbox"
                                  checked={filters.college['CAS']}
                                  onChange={() => handleCheckboxChange('college', 'CAS')}
                                  /> CAS (College of Arts and Sciences)</label><br/><br/>
                          <label><input 
                                  className="collegeCheck"
                                  type="checkbox"
                                  checked={filters.college['CAFS']}
                                  onChange={() => handleCheckboxChange('college', 'CAFS')}
                                  /> CAFS (College of Agriculture and Food Sciences)</label><br/><br/>
                          <label><input 
                                  className="collegeCheck"
                                  type="checkbox"
                                  checked={filters.college['CDC']}
                                  onChange={() => handleCheckboxChange('college', 'CDC')}
                                  /> CDC (College of Development Communication)</label><br/><br/>
                          <label><input
                                  className="collegeCheck"
                                  type="checkbox"
                                  checked={filters.college['CEM']}
                                  onChange={() => handleCheckboxChange('college', 'CEM')}
                                  /> CEM (College of Economics and Management)</label><br/><br/>
                          <label><input 
                                  className="collegeCheck"
                                  type="checkbox"
                                  checked={filters.college['CEAT']}
                                  onChange={() => handleCheckboxChange('college', 'CEAT')}
                                  /> CEAT (College of Engineering and Agro-Industrial Technology)</label><br/><br/>
                          <label><input 
                                  className="collegeCheck"
                                  type="checkbox"
                                  checked={filters.college['CFNR']}
                                  onChange={() => handleCheckboxChange('college', 'CFNR')}
                                  /> CFNR (College of Forestry and Natural Resources)</label><br/><br/>
                          <label><input 
                                  className="collegeCheck"
                                  type="checkbox"
                                  checked={filters.college['CHE']}
                                  onChange={() => handleCheckboxChange('college', 'CHE')}
                                  /> CHE (College of Human Ecology)</label><br/><br/>
                          <label><input of
                                  className="collegeCheck"
                                  type="checkbox"
                                  checked={filters.college['CVM']}
                                  onChange={() => handleCheckboxChange('college', 'CVM')}
                                  /> CVM (Colege of Veterinary Medicine)</label><br/><br/>
                          <label><input 
                                  className="collegeCheck" 
                                  type="checkbox" 
                                  checked={filters.college['CPAF']}
                                  onChange={() => handleCheckboxChange('college', 'CPAF')}
                                  /> CPAf (College of Public Affairs and Development)</label><br/><br/>

                        </div>
                      </div>
                      <br/>

                      <h3>By Building</h3>
                      <div className="byBuilding">
                        <div className="filterCheckbox">

                          <label><input 
                                  className="buildingCheck" 
                                  type="checkbox" 
                                  checked={filters.building['Physical Sciences']}
                                  onChange={() => handleCheckboxChange('building', 'Physical Sciences')}
                                  /> Physical Sciences Building</label><br/><br/>
                          <label><input 
                                  className="buildingCheck" 
                                  type="checkbox" 
                                  checked={filters.building['casa1']}
                                  onChange={() => handleCheckboxChange('building', 'casa1')}
                                  /> CAS Annex 1</label><br/><br/>
                          <label><input 
                                  className="buildingCheck" 
                                  type="checkbox" 
                                  checked={filters.building['casa2']}
                                  onChange={() => handleCheckboxChange('building', 'casa2')}
                                  /> CAS Annex 2</label><br/><br/>
                          <label><input 
                                  className="buildingCheck" 
                                  type="checkbox" 
                                  checked={filters.building['casb']}
                                  onChange={() => handleCheckboxChange('building', 'casb')}
                                  /> CAS Building</label><br/><br/>
                          <label><input 
                                  className="buildingCheck" 
                                  type="checkbox" 
                                  checked={filters.building['su']}
                                  onChange={() => handleCheckboxChange('building', 'su')}
                                  /> Student Union Building</label><br/><br/>
                          <label><input 
                                  className="buildingCheck" 
                                  type="checkbox" 
                                  checked={filters.building['CEM Building']}
                                  onChange={() => handleCheckboxChange('building', 'CEM Building')}
                                  /> CEM Building</label><br/><br/>
                        <label><input 
                                className="buildingCheck" 
                                type="checkbox" 
                                checked={filters.building['IBS and CPC Greenhouses and Annex Offices']}
                                onChange={() => handleCheckboxChange('building', 'IBS and CPC Greenhouses and Annex Offices')}
                                /> IBS and CPC Greenhouses and Annex Offices</label><br/><br/>
                        <label><input 
                                className="buildingCheck" 
                                type="checkbox" 
                                checked={filters.building['Francisco O. Santos Hall']}
                                onChange={() => handleCheckboxChange('building', 'Francisco O. Santos Hall')}
                                /> Francisco O. Santos Hall</label><br/><br/>
                        </div>
                      </div>
                      <br/>

                      <h3>Classification</h3>
                      <div className="byClassification">
                        <div className="filterCheckbox">
              
                          <label><input 
                                  className="classCheck" 
                                  type="checkbox" 
                                  checked={filters.classification['isOpen']}
                                  onChange={() => handleCheckboxChange('time', 'isOpen')}
                                  /> Open Now</label><br/><br/>
                          <label><input 
                                  className="classCheck" 
                                  type="checkbox" 
                                  checked={filters.classification['bidet']}
                                  onChange={() => handleCheckboxChange('classification', 'bidet')}
                                  /> Bidet</label><br/><br/>
                          <label><input 
                                  className="classCheck" 
                                  type="checkbox" 
                                  checked={filters.classification['tissue_paper']}
                                  onChange={() => handleCheckboxChange('classification', 'tissue_paper')}
                                  /> Tissue Paper</label><br/><br/>
                          <label><input 
                                  className="classCheck" 
                                  type="checkbox" 
                                  checked={filters.classification['soap']}
                                  onChange={() => handleCheckboxChange('classification', 'soap')}
                                  /> Soap</label><br/><br/>
                          <label><input 
                                  className="classCheck" 
                                  type="checkbox" 
                                  checked={filters.classification['hand_dryer']}
                                  onChange={() => handleCheckboxChange('classification', 'hand_dryer')}
                                  /> Hand Dryer</label><br/><br/>
                          <label><input 
                                  className="classCheck" 
                                  type="checkbox" 
                                  checked={filters.classification['pwd_toilet']}
                                  onChange={() => handleCheckboxChange('classification', 'pwd_toilet')}
                                  /> PWD Toilet</label><br/><br/>
                          <label><input 
                                  className="classCheck" 
                                  type="checkbox" 
                                  checked={filters.gender['male']}
                                  onChange={() => handleCheckboxChange('gender', 'male')}
                                  /> Male Restroom</label><br/><br/>
                          <label><input 
                                  className="classCheck" 
                                  type="checkbox" 
                                  checked={filters.gender['female']}
                                  onChange={() => handleCheckboxChange('gender', 'female')}
                                  /> Female Restroom</label><br/><br/>
              
                        </div>
                      </div>
                      <br/>

                      <h3>Ratings</h3>
                      <div className="byRatings">
                        <div className="filterCheckbox">

                          <label><input 
                                  className="rateCheck" 
                                  type="checkbox" 
                                  rel="five" 
                                  checked={filters.rating['5']}
                                  onChange={() => handleCheckboxChange('rating', '5')}
                                  /> 5 Stars</label><br/><br/>
                          <label><input 
                                  className="rateCheck" 
                                  type="checkbox" 
                                  rel="four" 
                                  checked={filters.rating['4']}
                                  onChange={() => handleCheckboxChange('rating', '4')}
                                  /> 4 Stars and up</label><br/><br/>
                          <label><input 
                                  className="rateCheck" 
                                  type="checkbox" 
                                  rel="three" 
                                  checked={filters.rating['3']}
                                  onChange={() => handleCheckboxChange('rating', '3')}
                                  /> 3 Stars and up</label><br/><br/>
                          <label><input 
                                  className="rateCheck" 
                                  type="checkbox" 
                                  rel="two" 
                                  checked={filters.rating['2']}
                                  onChange={() => handleCheckboxChange('rating', '2')}
                                  /> 2 Stars and up</label><br/><br/>
                          <label><input 
                                  className="rateCheck" 
                                  type="checkbox" 
                                  rel="one" 
                                  checked={filters.rating['1']}
                                  onChange={() => handleCheckboxChange('rating', '1')}
                                  /> 1 Star and up</label><br/><br/>

                        </div>
                      </div>
                      <br/>

                      <button className="clearFilter" onClick={clearFilters}><VscClearAll className="symbol"/> Clear All</button>

                    </div>
                  </Popup>
                </div>
              ) : null }
              <Link
                to="#"
                className={`button regular ${
                  activeButton === "BEST" ? "active" : ""
                }`}
                onClick={() => handleButtonClick("BEST")}
              >
                <FaRegStar />
                <span>BEST</span>
              </Link>
              <Link
                to="#"
                className={`button regular ${
                  activeButton === "WORST" ? "active" : ""
                }`}
                onClick={() => handleButtonClick("WORST")}
              >
                <FaStar />
                <span>WORST</span>
              </Link>
              <Link
                to="#"
                className={`button regular ${
                  activeButton === "RECENT" ? "active" : ""
                }`}
                onClick={() => handleButtonClick("RECENT")}
              >
                <FaBell />
                <span>RECENT ACTIVITY</span>
              </Link>
            </div>
            <div className={`card-gallery ${searchResults.length < 4 ? 'increased-gap' : ''}`}>
              {searchResults.length > 0 ? (
                sortedResults()
               ) : (
                  <div className="noResults">
                    No results found
                  </div>
               )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SearchPage
